





























import Vue from "vue";
import { mapState } from "vuex";
import { Component } from "vue-property-decorator";
import { IState } from "@/store";
@Component({
  components: {
    "navigation-header": () => import("./navigationHeader.vue"),
    "navigation-body": () => import("./navigationBody.vue"),
    "navigation-footer": () => import("./navigationFooter.vue")
  },
  computed: {
    ...mapState({
      navIsOpen: (state: IState) => state.ui.nav.isOpen,
      navIsOverlaid: (state: IState) => state.ui.nav.isOverlaid
    })
  }
})
export default class AdminNavigation extends Vue {
  // Data
  public navIsOpen!: boolean;
  public navIsOverlaid!: boolean;
  // Computed
  public get dynamicHeight(): string {
    return `${this.$store.state.ui.window.height}px`;
  }
  public get navIsCollapsed(): boolean {
    if (this.$route.path.startsWith("/admin/support/inbox")) return true;
    return this.$_.get(this.$store.state, "ui.nav.isCollapsed");
  }
  // Methods
  public showOverlay() {
    if (this.navIsOverlaid || !this.navIsCollapsed) return;
    this.$store.commit("ui/overlayNav", true);
  }
  public hideOverlay() {
    if (!this.navIsOverlaid) return;
    this.$store.commit("ui/overlayNav", false);
  }
}
